export { }

document.querySelectorAll(".i-header-dropdown").forEach(dropdown => {
  dropdown.addEventListener("mouseenter", () => {
    dropdown.classList.remove("--open")
  })
})
